var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "breadcrumb" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { "separator-class": "el-icon-arrow-right" } },
        _vm._l(_vm.breadCrumbList, function(item, index) {
          return _c(
            "el-breadcrumb-item",
            {
              key: item.name,
              attrs: {
                to:
                  index <= _vm.breadCrumbList.length ? { path: item.path } : ""
              }
            },
            [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm.suffix
        ? _c("span", { staticClass: "suffix" }, [_vm._v(_vm._s(_vm.suffix))])
        : _vm._e(),
      _vm._v(" "),
      _vm.dsOrder
        ? _c("span", { staticClass: "suffix" }, [_vm._v(_vm._s(_vm.dsOrder))])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-110bf0aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-110bf0aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/custom-breadcrumb.vue
// module id = tqPe
// module chunks = 2